<template>
  <div>
      <div v-if="$store.state.core.bundles!=null">
        <BundlePopup :bundle_list="get_bundle(item.id)" :bundle="item" v-for="(item, index) in $store.state.core.bundles.labels" :key="item.id+'_'+index" />
      </div>
  </div>
</template>

<script>
import BundlePopup from "./BundlePopup"
export default {
  name: "BundleCommon",
  components: {BundlePopup},
  methods:{
     get_bundle: function (bundle_id) {
      var blds = this.$store.state.core.bundles[bundle_id];
      var bdl_list = [];
      for (let index = 0; index < blds.length; index++) {
        const element = blds[index];
        if (!_.isUndefined(element.price)) {
          element.price = parseInt(element.price);
        }
        
        if(!_.isUndefined(element.price) && element.price > 0 && element.price < 1000000) {
          bdl_list.push(element);
        }
      }
      return _.orderBy(bdl_list, "price", "asc");
    }
  }
};
</script>